module.exports = __webpack_public_path__ + "static/media/clear.c4419682.jpg";